// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool } from 'prop-types'

const SortIcon = ({ asc, showIcon }) => (
  showIcon
    ? <i className={`sort-icon fa fa-caret-${asc ? 'down' : 'up'}`} />
    : null
)

SortIcon.propTypes = {
  asc: bool.isRequired,
  showIcon: bool.isRequired,
}

export default SortIcon
